<template>
  <project-base :state="state">
    <article class="container mt-6">
      <h2 class="text-3xl mb-12">
        {{ contract.title }}
      </h2>
      <div class="flex items-start">
        <nav
          class="hidden lg:block w-1/3 sticky"
          style="top: 6rem"
        >
          <h3 class="text-base border-b mb-6 pb-2 mt-1">
            Contract Sections
          </h3>
          <ul class="list-reset">
            <li
              v-for="({heading}, index) in contract.sections"
              :key="index"
              class="mb-2"
            >
              <a
                data-turbolinks="false"
                :href="'#section_' + index"
              >{{ heading }}</a>
            </li>
            <li
              v-if="project.conditions"
              class="mb-2"
            >
              <a
                data-turbolinks="false"
                href="#section_appendix"
              >Appendix: Conditions</a>
            </li>
          </ul>
        </nav>
        <div class="flex-1 md:pl-8">
          <div
            v-for="(section, index) in contract.sections"
            :key="index"
            :class="{
              'mt-12': index > 0
            }"
          >
            <h3
              :id="'section_' + index"
              class="mb-6 text-xl border-b pb-2"
            >
              {{ section.heading }}
            </h3>
            <div
              class="content contract"
              v-html="parseMarkdown(section.content)"
            />
          </div>
          <div
            v-if="project.conditions"
            class="mt-12"
          >
            <h3
              id="section_appendix"
              class="mb-6 text-xl border-b pb-2"
            >
              Appendix: Contractual Conditions
            </h3>
            <div
              class="content contract"
              v-html="parseMarkdown(project.conditions)"
            />
          </div>
        </div>
      </div>
      <staff-details
        :project="project"
        :staff="staff"
        :loading="loading"
        :errors="errors"
      />
      <account-details
        :project="project"
        :details="account"
        :loading="loading"
        :errors="errors"
      />
      <div class="md:w-2/3 md:ml-auto mt-12 md:pl-8">
        <div class="w-64">
          <app-button
            :disabled="hasErrors"
            @click="showConfirmationModal = true"
          >
            Sign Contract
          </app-button>
        </div>
      </div>
      <contract-confirmation
        v-if="showConfirmationModal"
        :loading="loading"
        :project="project"
        :user="state.user"
        :confirmation="confirmation"
        @contract:submit="submitContract"
        @close="showConfirmationModal = false"
      />
    </article>
  </project-base>
</template>
<script>
import { userProjectMixin } from '../../mixins/userProject.js'
export default {
  name: 'ShowContract',
  mixins: [userProjectMixin],
  data() {
    return {
      loading: false,
      errors: {},
      showConfirmationModal: false,
      staff: [
        {
          name: '',
          job_title: '',
          salary: null,
          employer_nic: null,
          employer_pension: null,
          medical_health_premiums: null,
          life_assurance_premiums: null
        },
      ],
      account: {
        account_name: '',
        sort_code: '',
        account_number: '',
        bank_name: '',
        bank_address: ''
      },
      confirmation: {
        signature: ''
      }
    }
  },
  computed: {
    allStaffValid() {
      return this.staff.filter(staffMember => {
        return (staffMember.name && staffMember.name.length > 2)
          && (staffMember.job_title && staffMember.job_title.length > 2)
          && (staffMember.salary && staffMember.salary > 0)
      }).length === this.staff.length
    },
    hasErrors() {
      const keys = Object.keys(this.account)
      let errors = 0
      keys.map(key => {
        const method = key.replace(/_(.)/g, (match, char) => char.toUpperCase() ).replace('_', '')
        let isValid = this[`${method}Validation`]()
        if(isValid) return;
        errors++
      })
      return errors > 0 || !this.allStaffValid
    }
  },
  watch: {
    'account.sort_code': function(val) {
      this.account.sort_code = this.numbersOnly(val)
    },
    'account.account_number': function(val) {
      this.account.account_number = this.numbersOnly(val)
    }
  },
  methods: {
    numbersOnly(val) {
      return val.replace(/\D/g, '')
    },
    accountNameValidation() {
      const account_name = this.account.account_name
      return this.notEmpty(account_name)
    },
    sortCodeValidation() {
      const sort_code = this.account.sort_code
      return this.notEmpty(sort_code) && this.hasLength(sort_code, 6) && this.isNumber(sort_code)
    },
    accountNumberValidation() {
      const account_number = this.account.account_number
      return this.notEmpty(account_number) && this.isNumber(account_number)
    },
    bankNameValidation() {
      const bank_name = this.account.bank_name
      return this.notEmpty(bank_name)
    },
    bankAddressValidation() {
      const bank_address = this.account.bank_address
      return this.notEmpty(bank_address)
    },
    notEmpty(val) {
      return val !== null && val !== undefined && val.length
    },
    hasLength(val, length) {
      return val.length === length
    },
    isNumber(val) {
      return Number.parseInt(val)
    },
    submitContract() {
      // const data = Object.freeze({
      //   ...this.account,
      //   ...this.confirmation
      // })
      this.loading = true
      axios.post(window.location.href, {...this.account, staff: this.staff })
        .then(data => {
          // eslint-disable-next-line no-console
          console.log(data)
          Turbolinks.visit(route('projects.contracts.index', this.project.uuid))
        })
        .catch(error => {
          // eslint-disable-next-line no-console
          console.error(error.response)
          if (error.response.status === 422) {
            this.errors = error.response.data.errors
          }

          this.showConfirmationModal = false;
          this.loading = false;
        })
    }
  }
}
</script>
